import axios from "axios";
import authHeader from "./auth-header";
import axiosInstance from "./axios.instance";

export const API_URL = "https://api.suuplink.suave.ppg.br/api/";

const getPages = () => {
  return axiosInstance.get(API_URL + "admin/pages",
   { headers: authHeader() });
};

const getPage = ({ id }) => {
  return axios.get(API_URL + `pages/${id}`);
};

const updatePage = async ({ idId, newPage, admin }) => {
  try {
    return await axios({
      method: "put",
      url: API_URL + `admin/pages/${idId}`,
      headers: {
        "Content-Type": "application/json",
        "x-access-token": admin.accessToken,
      },
      data: newPage,
    });
  } catch (err) {
    return console.log(err);
  }
};

const deletePage = async ({ id, admin }) => {
  try {
    return await axios({
      method: "delete",
      url: API_URL + `admin/pages/${id}`,
      headers: {
        "Content-Type": "application/json",
        "x-access-token": admin.accessToken,
      },
    });
  } catch (err) {
    return console.log(err);
  }
};

const postPage = async ({ newPage, admin }) => {
  let pageData = newPage;
  console.log(pageData);
  return await axios({
    method: "post",
    url: API_URL + `admin/pages/`,
    data: pageData,
    headers: {
      "Content-Type": "application/json",
      "x-access-token": admin.accessToken,
    },
  });
};

const postImages = async ({ coverData, avatarData, admin, currentPageId }) => {
  await axios({
    method: "post",
    url: API_URL + `admin/pages/${currentPageId}/upload-cover`,
    data: coverData,
    headers: {
      "x-access-token": admin.accessToken,
    },
  });

  return await axios({
    method: "post",
    url: API_URL + `admin/pages/${currentPageId}/upload-avatar`,
    data: avatarData,
    headers: {
      "x-access-token": admin.accessToken,
    },
  });
};

const pageService = {
  getPage,
  getPages,
  updatePage,
  postPage,
  postImages,
  deletePage,
};

export default pageService;
